<template>
	<div style="height:375px;">
		<h4 class="inner_h5" style="height: 35px;">
			User Defined Group Class
			<span>
				<a href="javascript:void(0);" class="gray_bt" @click="save()" style="float:right;">Save</a>
			</span>
		</h4>
		<div class="fixed-table-container340" ref="div_wrapper_parent">
			<div class="table-wrapper" ref="div_wrapper_box">
				<table class="list_tbl tbl_pointer" border="0">
					<colgroup>
						<col style="width:5%;" />
						<col />
						<!--						<col style="width:20%;" />-->
						<!--						<col style="" />-->
						<!--						<col style="width:20%;" />-->
						<!--						<col style="width:5%;" />-->
					</colgroup>
					<thead>
						<tr>
							<th class="al_center"><div class="th-text">No</div></th>
							<th class="al_center">
								<div class="th-text">{{ headers.class }} Code</div>
							</th>
							<!--							<th class="al_center"><div class="th-text">WH Code</div></th>-->
							<!--							<th class="al_center"><div class="th-text">Class Name</div></th>-->
							<!--							<th class="al_center"><div class="th-text">Group</div></th>-->
							<!--							<th class="al_center"><div class="th-text">Items</div></th>-->
						</tr>
					</thead>
					<tbody>
						<tr v-for="(cls, index) of filterList" v-bind:key="index" @dblclick="deleteClass(index)">
							<td>{{ index + 1 }}</td>
							<td>{{ cls.classCode }}</td>
							<!--							<td>{{ cls.wh_code }}</td>-->
							<!--							<td>{{ cls.name }}</td>-->
							<!--							<td>{{ cls.class_group_name }}</td>-->
							<!--							<td class="al_right">{{ cls.item_count | commaSeparated }}</td>-->
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import { apiInsertUserDefinedGroupClasses, apiSelectUserDefinedGroupClasses } from '@/api/item/userDefined';
import { objectToFormData } from '@/api/util';

export default {
	name: 'UserDefinedGroupClass',
	props: { value: Number },
	data: function() {
		return { list: [], searchName: '' };
	},
	computed: {
		filterList: function() {
			return this.list.filter(a => a.delYn === 'N');
		},
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	watch: {
		value: function() {
			this.selectList();
		},
	},
	methods: {
		async selectList() {
			if (this.value) {
				const { data } = await apiSelectUserDefinedGroupClasses(this.value);
				if (data) {
					data.forEach(a => (a.delYn = 'N'));
					this.list = data;
				} else {
					this.list = [];
				}
			}
		},
		setClass(code) {
			if (this.list.filter(cls => cls.classCode === code && cls.delYn === 'N').length > 0) {
				this.$toast.error('Already selected');
			} else {
				this.list.push({ classCode: code, delYn: 'N' });
			}
		},
		deleteClass(index) {
			this.filterList[index].delYn = 'Y';
		},
		async save() {
			let classList = [];
			this.list.filter(a => a.delYn === 'N').map(a => classList.push(a.classCode));
			const param = objectToFormData({
				classList: classList,
			});
			await apiInsertUserDefinedGroupClasses(this.value, param);
			this.$toast.success('Saved');
		},
	},
	mounted() {
		this.selectList();
	},
};
</script>
